import React, { useState, useEffect } from 'react'
import { Form, Button, Container, Row, Col, Modal, Breadcrumb, BreadcrumbItem, Nav } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { useGetformMutation } from '../../slices/formApiSlice'
import { parseUserInfo } from '../../utils/parseUtil'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { useGetOptionsMutation } from '../../slices/commonApiSlice'
import { parseOptionsData } from '../../utils/parseOptionsData'
import { useGetForm14ForEmployeeMutation } from '../../slices/adminApiSlice'
import { Typeahead } from 'react-bootstrap-typeahead'

const LeaveRegisterFormScreen = () => {

    const [year, setYear] = useState("")
    const [empType, setEmpType] = useState("")
    const [empCode, setEmpCode] = useState("")
    const [activeType, setActiveType] = useState("0")
    const [reportType, setReportType] = useState("0")
    const [showModal, setShowModal] = useState(false)
    const [pdfUrl, setPdfUrl] = useState("")
    const [yearsOptions, setYearsOptions] = useState([]);


    const { userInfo } = useSelector((state) => state.auth)
    const [getOptions, { isLoading: getOptionsLoading }] = useGetOptionsMutation()
    const [getForm14ForEmployee, { isLoading }] = useGetForm14ForEmployeeMutation()

    const [employeeTypes, setEmployeeTypes] = useState([])
    const [designations, setDesignations] = useState([])
    const [departments, setDepartments] = useState([])


    useEffect(() => {
        const now = new Date()
        const currentYear = now.getFullYear()

        const startYear = parseInt(process.env.REACT_APP_START_YEAR, 10 || 2020)

        const options = []
        for (let i = startYear; i <= currentYear + 1; i++) {
            options.push(i)
        }

        setYearsOptions(options)
        setYear(currentYear.toString())


        // Fetch options data on component load
        const fetchOptions = async () => {
            try {
                const reqCompanyCode = userInfo[13]?.InfoField || '1' // Default to '1' if not available

                const formData = new FormData()
                formData.append('title', 'GetEmployeeMasterDataList')
                formData.append('ReqCompanyCode', reqCompanyCode)

                const res = await getOptions(formData)

                const parsedOptions = parseUserInfo(res)
                const parsedData = parseOptionsData(parsedOptions)

                console.log(parsedData, "12")

                if (parsedData) {
                    setEmployeeTypes(parsedData.employeeTypes)
                    setDesignations(parsedData.designations)
                    setDepartments(parsedData.departments)
                } else {
                    toast.error('Failed to load options')
                }
            } catch (err) {
                console.error('Error fetching options:', err)
                toast.error('Error fetching options')
            }
        }

        fetchOptions()
    }, [getOptions, userInfo])


    const handleSubmit = async (e) => {
        e.preventDefault()

        const reqCompanyCode = userInfo[13]?.InfoField
        const reqEmpCode = userInfo[1]?.InfoField

        const formData = new FormData()
        formData.append('title', 'GetForm14ForEmployee')
        formData.append('ReqYear', year)
        formData.append('ReqActiveType', activeType)
        formData.append('ReqEmpCode', reqEmpCode)
        formData.append('ReqEmpType', empType)
        formData.append('ReqCompanyCode', reqCompanyCode)
        formData.append('ReqRptType', reportType)


        // Log formData contents
        for (let [key, value] of formData.entries()) {
            console.log(`${key}: ${value}`)
        }


        try {
            const res = await getForm14ForEmployee(formData)

            const parsedData = parseUserInfo(res)

            if (parsedData && Array.isArray(parsedData) && parsedData.length > 0) {
                const data = parsedData[0]

                if (data.ErrorCode === '0') {
                    let pdfPath = data.JSONData1

                    if (pdfPath.startsWith('/api/WebServiceForStaffData.aspx/')) {
                        pdfPath = pdfPath.replace('/api/WebServiceForStaffData.aspx/', '/')
                    }

                    const backendUrl = process.env.REACT_APP_URL
                    const pdfUrl = `${backendUrl}${pdfPath}`

                    setPdfUrl(pdfUrl)
                    setShowModal(true)
                } else {
                    toast.error(data.ErrorMessage || 'An error occurred')
                }
            } else {
                toast.error('Failed to parse user info')
            }
        } catch (err) {
            console.error('Error submitting data:', err)
            toast.error(err?.data?.message || 'Error submitting data')
        }
    }


    return (
        <>
            <Breadcrumb>
                <BreadcrumbItem>
                    <Nav.Link as={Link} to="/dashboard" className='text-success text-decoration-none'>
                        Dashboard
                    </Nav.Link>
                </BreadcrumbItem>
                <BreadcrumbItem active>
                    Yearly Leaves Report
                </BreadcrumbItem>
            </Breadcrumb>
            <Container className="form-container">

                <h4 className=" text-center">Yearly Leaves Report</h4>
                <Form className="border p-4 rounded bg-light mb-4" onSubmit={handleSubmit}>
                    <Row className="" >
                        <Col md={6}>
                            <Form.Group controlId="year">
                                <Form.Label>Year</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={year}
                                    onChange={(e) => setYear(e.target.value)}
                                    className="form-control-hover"
                                    required
                                >
                                    {yearsOptions.map((yr) => (
                                        <option key={yr} value={yr}>
                                            {yr}
                                        </option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="empCode" className="mb-3">
                                <Form.Label>Employee Code</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter Employee Code"
                                    value={empCode}
                                    onChange={(e) => setEmpCode(e.target.value)}
                                    required
                                    className="form-control-hover"
                                />
                            </Form.Group>
                        </Col>

                    </Row>
                    <Row className="mb-3">
                        <Col md={6}>
                            <Form.Group controlId="empType">
                                <Form.Label>Employee Type</Form.Label>
                                <Typeahead
                                    id="empType-typeahead"
                                    onChange={(selected) => setEmpType(selected[0])}
                                    options={employeeTypes}
                                    placeholder="Choose an employee type..."
                                    selected={empType ? [empType] : []}
                                    className="form-control-hover"
                                    required
                                />
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group controlId="activeType">
                                <Form.Label>Active Type</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={activeType}
                                    onChange={(e) => setActiveType(e.target.value)}
                                    className="form-control-hover"
                                    required
                                >
                                    <option value="0">All</option>
                                    <option value="1">Active</option>
                                    <option value="2">Dropped</option>
                                </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3" >
                        <Col md={12}>
                            <Form.Group>
                                <Form.Label><div className="headline">Report Type</div></Form.Label>
                                <div className="d-flex">
                                    <Form.Check
                                        type="radio"
                                        id="reportType"
                                        name="reportType"
                                        label="Leaves Form 14 (Yearly)"
                                        value="0"
                                        checked={reportType === "0"}
                                        onChange={(e) => setReportType(e.target.value)}
                                        className="mx-3"
                                    />
                                    <Form.Check
                                        type="radio"
                                        id="reportType"
                                        name="reportType"
                                        label="Leaves Form 15 (Yearly)"
                                        value="1"
                                        checked={reportType === "1"}
                                        onChange={(e) => setReportType(e.target.value)}
                                    />
                                    <Form.Check
                                        type="radio"
                                        id="reportType"
                                        name="reportType"
                                        label="Leaves Sumamry (Yearly)"
                                        value="2"
                                        checked={reportType === "2"}
                                        onChange={(e) => setReportType(e.target.value)}
                                    />
                                </div>
                            </Form.Group>
                        </Col>

                    </Row>
                    <Row className="mb-3 text-center">
                        <Col>
                            <Button
                                type="submit"
                                variant="danger"
                                className="px-4"
                                disabled={isLoading || getOptionsLoading}
                            >
                                {isLoading || getOptionsLoading ? 'Loading...' : 'PRINT PDF'}
                            </Button>
                        </Col>
                        <Col>
                            <Button
                                type="submit"
                                variant="success"
                                className="px-4"
                                disabled={isLoading || getOptionsLoading}
                            >
                                {isLoading || getOptionsLoading ? 'Loading...' : 'PRINT EXCEL'}
                            </Button>
                        </Col>
                    </Row>
                </Form>
                <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Yearly Leaves Report</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <iframe
                            src={pdfUrl}
                            width="100%"
                            height="500px"
                            title="Yearly Leaves Report"
                        ></iframe>
                    </Modal.Body>
                </Modal>
            </Container>
        </>
    )
}

export default LeaveRegisterFormScreen
